
'use client';


import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { Component } from "react";
import * as Yup from "yup";
import UserService from "../../../services/UserService";
import JobApplicationEntity from "../../../types/jobApplicationEntity.type";
import JobsView from "../../jobs/JobsView";
import ViewUserSettings from "../../user-settings/UserSettingsView";
import ViewJobApplications from "../JobApplicationsView";

type Props = {
  userId: number |null | undefined,
  jobApplicationEntity: JobApplicationEntity
};

type State = {
  loading: boolean,
  message: string,
  showEditUser: boolean,
  showEditUserSettings: boolean,
  showUserPostedJobs: boolean,
  showUserApplications: boolean
};

export default class JobApplicationDetailView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.updateUser = this.updateUser.bind(this);

    this.state = {
      loading: false,
      message: "",
      showEditUser: false,
      showEditUserSettings: false,
      showUserApplications: false,
      showUserPostedJobs: false
    };

  }


  updateUser(formValue: {
    userId: number, approved: boolean, job: number
  }) {
    const { userId, approved, job } = formValue;

    this.setState({
      loading: true,
      message: "",
      showEditUser: true,
      showEditUserSettings: false,
      showUserPostedJobs: false,
      showUserApplications: false
    });


    const modifiedJobApplicationEntityEntity = this.props.jobApplicationEntity

    modifiedJobApplicationEntityEntity.userId = userId;
    modifiedJobApplicationEntityEntity.approved = approved;
    modifiedJobApplicationEntityEntity.job = job;

    console.log(JSON.stringify(modifiedJobApplicationEntityEntity));

    UserService.updateUserBoard(this.props.jobApplicationEntity.id, modifiedJobApplicationEntityEntity).then(
      () => {
        window.location.replace("users");
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage,
          showEditUser: false
        });
      }
    );
  }

  validationSchema() {
    return Yup.object().shape({
      email: Yup.string().required("This field is required!"),
      fullname: Yup.string().required("This field is required!"),
    });
  }

  viewMyApplications() {
    this.setState({
      showUserApplications: !this.state.showUserApplications
    });
  }
  viewAddedJobs() {
    this.setState({
      showUserPostedJobs: !this.state.showUserPostedJobs
    });
  }
  viewUserSettings() {
    this.setState({
      showEditUserSettings: !this.state.showEditUserSettings
    });
  }
  viewEditUser() {
    this.setState({
      showEditUser: !this.state.showEditUser
    });
  }


  render() {


    const jobApplicationEntity = this.props.jobApplicationEntity;
    const userId = this.props.userId;

    const { loading, message } = this.state;

    const initialValues = {
      job: jobApplicationEntity.job!,
      userId: jobApplicationEntity.userId!,
      approved: jobApplicationEntity.approved!,
    };


    let form = <>
      <Formik
        initialValues={initialValues}
        validationSchema={this.validationSchema}
        onSubmit={this.updateUser}
        enableReinitialize={true}
      >
        <Form>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <Field name="email" type="text" className="form-control" />
            <ErrorMessage
              name="email"
              component="div"
              className="alert alert-danger"
            />
          </div>

          <div className="form-group">
            <label htmlFor="fullname">Fullname</label>
            <Field name="fullname" type="text" className="form-control" />
            <ErrorMessage
              name="fullname"
              component="div"
              className="alert alert-danger"
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact">Contact</label>
            <Field name="contact" type="text" className="form-control" />
            <ErrorMessage
              name="contact"
              component="div"
              className="alert alert-danger"
            />
          </div>
          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Edit</span>
            </button>
          </div>

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
        </Form>
      </Formik>
    </>



    return (
      <div className="container">

      </div >
    );
  }
}